import Vue from 'vue'
import GtmTracking from 'chimera/all/plugins/tracking/gtm'

export default ({ env, store }) => {
  Vue.use(GtmTracking, {
    gtmId: env.gtmId,
    store,
  })
}
